import React, { useEffect, useState } from 'react';
import { Box, Button, Grid } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faSync } from '@fortawesome/pro-duotone-svg-icons';
import { useForm } from 'react-hook-form';
import { endOfDay } from 'date-fns';
import { TitleLabel } from '../../Element/LabelInputForm';
import { DatePicker, useDateInput } from 'react-nice-dates';
import { enUS } from 'date-fns/locale';
import 'react-nice-dates/build/style.css';
import dayjs from 'dayjs';
import { Input } from '../../../assets/styled/Element';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';

const Filter6level = ({
   onSubmit,
   isLoading = false,
   defaultSubmitFirstParams = false,
   startDate = new Date(moment().subtract(1, 'years')),
   endDate = new Date(),
}) => {
   const {
      control,
      register,
      watch,
      setValue,
      getValues,
      handleSubmit,
      unsubscribe,
   } = useForm({
      defaultValues: {
         startDate: startDate,
         endDate: endDate,
      },
   });

   const selectStartDate = watch('startDate');
   const selectEndDate = watch('endDate');

   useEffect(() => {
      register({ name: 'startDate' });
      register({ name: 'endDate' });
   }, [register]);

   useEffect(() => {
      init();
   }, []);

   const init = () => {
      if (defaultSubmitFirstParams) {
         handleSubmit(submit)();
      }
   };

   // on select date
   const handleStartDateChange = (e) => setValue('startDate', e);
   const handleEndDateChange = (type) => (e) => {
      if (type === 'auto') setValue('endDate', endOfDay(e));
      else setValue('endDate', e);
   };

   const handleReset = () => {
      setValue('startDate', startDate);
      setValue('endDate', endDate);
      init();
   };

   const submit = async (e) => {
      let params = e;
      params.startDateString = moment(e.startDate).format('DD/MM/YYYY');
      params.endDateString = moment(e.endDate).format('DD/MM/YYYY');
      onSubmit(params);
   };

   return (
      <form onSubmit={handleSubmit(submit)}>
         <Box fontSize={20}>
            <Grid container spacing={2}>
               <Grid item xs={2}>
                  <TitleLabel Fs={'14px'}>เริ่มต้น&nbsp;:&nbsp;</TitleLabel>
                  <Box width={'100%'} style={{ position: 'relative' }}>
                     <DatePicker
                        date={selectStartDate}
                        onDateChange={handleStartDateChange}
                        locale={enUS}
                        maximumDate={getValues('endDate')}
                     >
                        {({ inputProps, focused }) => (
                           <Input
                              className={'input' + (focused ? ' -focused' : '')}
                              {...inputProps}
                              value={`${
                                 inputProps.value &&
                                 dayjs(new Date(inputProps.value)).format(
                                    'DD/MM/BBBB',
                                 )
                              }`}
                           />
                        )}
                     </DatePicker>
                  </Box>
               </Grid>
               <Grid item xs={2}>
                  <TitleLabel Fs={'14px'}>สิ้นสุด&nbsp;:&nbsp;</TitleLabel>
                  <Box width={'100%'} style={{ position: 'relative' }}>
                     <DatePicker
                        date={selectEndDate}
                        onDateChange={handleEndDateChange('auto')}
                        minimumDate={
                           getValues('startDate')
                              ? getValues('startDate')
                              : new Date()
                        }
                        locale={enUS}
                     >
                        {({ inputProps, focused }) => (
                           <Input
                              className={'input' + (focused ? ' -focused' : '')}
                              {...inputProps}
                              value={`${
                                 inputProps.value &&
                                 dayjs(new Date(inputProps.value)).format(
                                    'DD/MM/BBBB',
                                 )
                              }`}
                           />
                        )}
                     </DatePicker>
                  </Box>
               </Grid>
            </Grid>
            <Grid container spacing={2}>
               <Grid item xs={12}>
                  <Button
                     variant={'contained'}
                     size={'small'}
                     color={'primary'}
                     type={'submit'}
                     startIcon={
                        isLoading ? (
                           <CircularProgress size={20} color={'primary'} />
                        ) : (
                           <FontAwesomeIcon icon={faSearch} size={'s'} />
                        )
                     }
                     disabled={isLoading}
                  >
                     ค้นหา
                  </Button>
                  <Button
                     variant={'contained'}
                     disableElevation
                     size={'small'}
                     onClick={handleReset}
                     startIcon={<FontAwesomeIcon icon={faSync} size={'s'} />}
                  >
                     รีเฟรช
                  </Button>
               </Grid>
            </Grid>
         </Box>
      </form>
   );
};

export default Filter6level;
